module.exports = __webpack_public_path__ + "img/logo-color.e6382167.png";